import type { ChoiceOption } from "modules/record/shared/hooks/useChoiceOptions";
import SysTable from "./sys-table";

interface ISysColumnParams {
    id: string;
    sys_table_id: string;
    active: boolean;
    label: string;
    name: string;
    column_type: string;
    column_subtype: string;
    order: number;
    referenced_table_name: string;
    reference_filter: string;
    currency_code: string;
    currency_decimal_places: number | null;
    default_value: string;
    default_value_type?: string;
    translation_public?: boolean;
    default_value_script?: string;
    default_value_timeout_ms?: number | string | null;
    is_display: boolean;
    is_hidden: boolean;
    is_mandatory: boolean;
    is_read_only?: boolean | null;
    overridden?: Record<string, boolean>;
    source_sys_table_id?: string;
    depends_on_column_id: string;
    // sys_table: SysTable | null;
    created_at: Date;
    updated_at: Date;
    /**
     * PRIM-021 (design_prim_021_outcome_vocabulary.md): an inline closed vocabulary for VIRTUAL
     * columns only (e.g. FlussConditionBuilder's synthetic `var.outcome`) — columns that never
     * exist in sys_columns and therefore have no real sys_choice rows to resolve against.
     * useChoiceOptions honors this when present and skips the sys_choice query entirely. Nothing
     * from the backend ever populates this for a real catalog column; only code that fabricates a
     * synthetic SysColumn should set it.
     */
    options?: ChoiceOption[];
}

class SysColumn {
    constructor();
    constructor(data: ISysColumnParams);
    constructor(data?: ISysColumnParams) {
        this.id = data?.id ?? "";
        this.name = data?.name ?? "";
        this.label = data?.label ?? "";
        this.active = data?.active ?? false;
        this.is_display = data?.is_display ?? false;
        this.order = data?.order ?? 0;
        this.column_type = data?.column_type ?? "";
        this.column_subtype = data?.column_subtype ?? "";
        this.referenced_table_name = data?.referenced_table_name ?? "";
        this.reference_filter = data?.reference_filter ?? "";
        this.currency_code = data?.currency_code ?? "";
        this.currency_decimal_places = data?.currency_decimal_places ?? null;
        this.sys_table_id = data?.sys_table_id ?? "";
        this.default_value = data?.default_value ?? "";
        this.default_value_type = data?.default_value_type ?? "literal";
        this.translation_public = data?.translation_public ?? false;
        this.default_value_script = data?.default_value_script ?? "";
        this.default_value_timeout_ms = data?.default_value_timeout_ms ?? null;
        this.is_hidden = data?.is_hidden ?? false;
        this.is_mandatory = data?.is_mandatory ?? false;
        this.is_read_only = data?.is_read_only ?? null;
        this.overridden = data?.overridden ?? {};
        this.source_sys_table_id = data?.source_sys_table_id ?? data?.sys_table_id ?? "";
        this.depends_on_column_id = data?.depends_on_column_id ?? "";
        this.options = data?.options;
        // this.sys_table = null;

        this.created_at = new Date();
        this.updated_at = new Date();
    }

    id: string;
    label: string;
    name: string;
    active: boolean;
    is_display: boolean;
    order: number;
    column_type: string;
    column_subtype: string;
    referenced_table_name: string;
    reference_filter: string;
    currency_code: string;
    currency_decimal_places: number | null;
    sys_table_id: string;
    default_value: string;
    default_value_type: string;
    translation_public: boolean;
    default_value_script: string;
    default_value_timeout_ms: number | string | null;
    is_hidden: boolean;
    is_mandatory: boolean;
    is_read_only: boolean | null;
    overridden: Record<string, boolean>;
    source_sys_table_id: string;
    depends_on_column_id: string;
    // sys_table: SysTable | null;
    created_at: Date;
    updated_at: Date;
    options?: ChoiceOption[];

}
export default SysColumn;
